module.exports = __webpack_public_path__ + "img/EgyptTechSlinger3_ua.7bf919cd.webp";